import { CustomLogo } from '../../../../components/Logo';
import LanguageSelector from '../LanguageSelector/LanguageSelector';
import cx from 'classnames';
import { injectIntl, useIntl } from 'react-intl';
import React, { useState } from 'react';
import { LoesungenUndProdukteController } from '../../../../components/Illus/LoesungenUndProdukte/LoesungenUndProdukteController';
import { ReferenzenController } from '../../../../components/Illus/Referenzen/ReferenzenController';
import { messages } from '../../../../messages';

const BigHeader = ({
  pathname,
  items,
  leftNavTitles,
  rightNavTitles,
  intl,
}) => {
  const [navMaxExpandedItems, setNavMaxExpandedItems] = useState(null);
  const localization = useIntl();

  const referenceHref =
    localization.locale === 'de' ? '/de/referenzen' : '/en/references';
  const imprintHref =
    localization.locale === 'de' ? '/de/impressum' : '/en/imprint';

  const isActive = (url) => {
    return (url === '' && pathname === '/') || (url !== '' && pathname === url);
  };

  const getLeftNavItems = (itemsToChange) => {
    return itemsToChange.filter((item) => {
      return leftNavTitles.includes(item.title);
    });
  };

  const getRightNavItems = (itemsToChange) => {
    return itemsToChange.filter((item) => {
      return rightNavTitles.includes(item.title);
    });
  };

  const checkIfSubGroupIsHovered = (listObject) => {
    return listObject === navMaxExpandedItems;
  };

  const removeBlockHoverEffectFromNavItem = () => {
    Array.from(
      document.getElementsByClassName('x-nav-item-expanded-box'),
    ).forEach((element) => {
      element.classList.remove('x-block-expand');
    });
  };

  const addBlockHoverEffectToNavItem = () => {
    Array.from(
      document.getElementsByClassName('x-nav-item-expanded-box'),
    ).forEach((element) => {
      element.classList.add('x-block-expand');
    });
  };

  return (
    <>
      <div className="x-nav-wrapper">
        <ul className="x-nav-items-wrapper-left">
          {getLeftNavItems(items).map((item, index) => (
            <li key={index} className="x-nav-item x-nav-item-with-childs">
              <a
                onClick={addBlockHoverEffectToNavItem}
                onMouseEnter={() => {
                  removeBlockHoverEffectFromNavItem();
                }}
                href={item.url}
                className="x-nav-item-link"
              >
                <span>{item.title}</span>
              </a>

              <div className="x-nav-item-expanded-box">
                {item.url !== referenceHref ? (
                  <>
                    <div className="x-nav-item-list-border-wrapper x-nav-item-childs">
                      <div className="x-nav-item-border">
                        <ul className="x-nav-list-item-childs x-nav-item-childs-left">
                          {item.items.map((xItem, index) => (
                            <li
                              onMouseEnter={() => {
                                setNavMaxExpandedItems(xItem);
                              }}
                              onMouseLeave={() => {
                                setNavMaxExpandedItems(null);
                              }}
                              className={
                                checkIfSubGroupIsHovered(xItem)
                                  ? 'li-hovered'
                                  : ''
                              }
                              key={xItem.url}
                            >
                              <a
                                href={xItem.url}
                                className={cx({
                                  current: isActive(xItem.url),
                                })}
                                onClick={addBlockHoverEffectToNavItem}
                                onMouseEnter={() => {
                                  removeBlockHoverEffectFromNavItem();
                                }}
                              >
                                <p>{xItem.title}</p>
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                    <div
                      className="x-nav-item-list-border-wrapper x-nav-item-childs"
                      onMouseEnter={() => {
                        setNavMaxExpandedItems(navMaxExpandedItems);
                      }}
                      onMouseLeave={() => {
                        setNavMaxExpandedItems(null);
                      }}
                    >
                      <div
                        className={
                          navMaxExpandedItems !== null
                            ? 'x-nav-item-border'
                            : ''
                        }
                      >
                        <ul className="x-nav-list-item-childs x-nav-list-item-childs-right">
                          {navMaxExpandedItems !== null ? (
                            navMaxExpandedItems.items.map((yItem, index) => (
                              <li key={yItem.url}>
                                <a
                                  href={yItem.url}
                                  className={cx({
                                    current: isActive(yItem.url),
                                  })}
                                  onClick={addBlockHoverEffectToNavItem}
                                  onMouseEnter={() => {
                                    removeBlockHoverEffectFromNavItem();
                                  }}
                                >
                                  <p className="x-nav-right-text">
                                    {yItem.title}
                                  </p>
                                </a>
                              </li>
                            ))
                          ) : (
                            <></>
                          )}
                        </ul>
                      </div>
                    </div>
                    <div className="x-nav-item-childs">
                      <div className="x-nav-image-container">
                        <LoesungenUndProdukteController
                          hoveredItem={navMaxExpandedItems}
                        ></LoesungenUndProdukteController>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="x-nav-expanded-box-reference">
                    {item.items
                      .sort((a, b) => a.title.localeCompare(b.title))
                      .map((item, index) => (
                        <a
                          key={index}
                          href={item.url}
                          className="x-nav-item-reference"
                          onClick={addBlockHoverEffectToNavItem}
                          onMouseEnter={() => {
                            removeBlockHoverEffectFromNavItem();
                          }}
                        >
                          <div className="x-nav-item-reference-img-placeholder">
                            <ReferenzenController referenceItem={item} />
                          </div>
                          <p>{item.title}</p>
                        </a>
                      ))}
                  </div>
                )}
              </div>
            </li>
          ))}
        </ul>
        <a href={'/'} className={'x-nav-logo'}>
          <CustomLogo></CustomLogo>
        </a>
        <ul className="x-nav-items-wrapper-right">
          {getRightNavItems(items).map((item, index) => (
            <li key={index} className="x-nav-item x-nav-item-with-childs">
              <a
                href={item.url}
                className={cx({
                  current: isActive(item.url),
                })}
              >
                <span>{item.title}</span>
              </a>
            </li>
          ))}
          <li
            className="x-nav-item-social-media-link kontakt-link"
            title={intl.formatMessage(messages.contact)}
          >
            <a href={imprintHref}>
              <svg
                width="51.591461mm"
                height="35.079815mm"
                version="1.1"
                viewBox="0 0 5159.1461 3507.9815"
                id="svg1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <defs id="defs1"></defs>
                <g
                  id="Ebene_x0020_1"
                  transform="translate(-8231.5937,-12258.688)"
                >
                  <metadata id="CorelCorpID_0Corel-Layer" />
                  <path
                    d="m 10548,13864 c 32,-27 64,-61 97,-86 43,44 273,455 484,572 220,120 596,-155 772,-219 33,93 87,201 127,285 132,275 121,270 286,544 38,63 119,198 139,275 -74,-11 -144,-31 -218,-42 -217,-33 -397,-74 -613,-126 -193,-47 -407,-111 -594,-152 -55,-12 -149,-21 -177,-68 -37,-61 -54,-106 -92,-161 -80,-118 -234,-328 -393,-346 -104,-12 -159,99 -281,212 -58,54 -83,83 -176,36 -47,-24 -110,-80 -121,-130 z m -905,404 c 1,-42 69,-334 83,-413 24,-135 61,-262 89,-394 19,-87 161,-787 170,-803 54,51 500,801 548,923 l -776,601 c -41,34 -69,65 -114,86 z m -191,-309 c -30,-38 -51,-74 -75,-109 -53,-79 -49,-201 34,-251 27,-16 95,-49 128,-55 z m 2626,70 c 120,-61 894,-523 949,-538 -30,188 -127,593 -175,797 -29,125 -137,694 -200,765 -105,-203 -198,-335 -290,-512 -67,-129 -129,-275 -206,-396 -24,-38 -67,-86 -78,-116 z m -1324,1228 c -142,170 -566,288 -834,226 -151,-35 -136,-43 -213,-151 -104,-144 -201,-285 -300,-428 -99,-145 -201,-284 -298,-430 -96,-145 -190,-298 -285,-444 -97,-150 -212,-277 -296,-432 -102,-186 7,-435 104,-557 56,-70 115,-122 184,-180 40,-34 162,-127 212,-150 101,104 347,473 373,590 -57,50 -260,91 -282,356 -20,232 -3,219 151,461 136,215 307,591 545,708 290,143 421,-66 560,-194 101,36 359,510 379,625 z m 2237,-2058 c -102,51 -505,292 -633,368 -178,104 -981,574 -1101,553 -61,-11 -272,-293 -313,-356 -86,-133 -165,-274 -244,-416 -99,-176 -123,-236 -242,-418 -45,-68 -85,-133 -131,-199 l -138,-191 c 51,3 134,29 179,41 l 521,129 c 280,70 757,210 1037,259 253,45 482,106 717,149 39,7 316,54 348,81 z m -2010,1918 c 77,9 198,50 275,71 87,24 177,46 261,69 402,107 713,146 1100,237 124,30 184,-10 219,-103 57,-154 193,-624 226,-776 19,-87 33,-190 56,-282 22,-88 45,-174 63,-266 32,-161 130,-683 191,-817 45,-98 7,-194 -93,-205 -110,-11 -172,-40 -278,-61 -91,-18 -176,-38 -273,-54 -187,-31 -373,-81 -554,-114 -373,-68 -733,-162 -1082,-257 -180,-48 -356,-86 -536,-135 l -543,-126 c -41,-18 -57,-55 -124,-32 -38,14 -58,46 -77,92 -61,145 -135,635 -185,806 -20,-25 -142,-267 -203,-360 -79,-119 -305,-431 -473,-351 -36,18 -48,35 -90,54 -129,55 -297,211 -385,310 -151,171 -334,514 -195,826 66,147 322,497 436,681 23,37 841,1266 918,1317 101,67 309,121 435,125 164,6 350,-29 481,-79 121,-47 470,-244 488,-347 13,-79 -43,-150 -58,-223 z"
                    id="path1"
                  />
                </g>
              </svg>
            </a>
          </li>
          <li className="x-nav-item-social-media-link fernwartung-link">
            <a
              href="/de/fernwartung"
              title={intl.formatMessage(messages.remote_maintenance)}
            >
              <svg
                width="42.78186mm"
                height="35.079815mm"
                version="1.1"
                viewBox="0 0 4278.186 3508.0002"
                id="svg4"
                xmlns="http://www.w3.org/2000/svg"
              >
                <defs id="defs1"></defs>
                <g id="Ebene_x0020_1" transform="translate(-7420.3481,-12896)">
                  <metadata id="CorelCorpID_0Corel-Layer" />
                  <g
                    id="_698726272"
                    transform="matrix(0.63103559,0,0,0.63103559,2737.8444,4758.1651)"
                  >
                    <path
                      d="m 7804,13221 c 232,-8 449,-13 686,-12 l 3522,11 c 469,0 948,-9 1416,0 11,258 -7,544 -9,805 -1,274 0,548 0,822 0,273 0,547 0,821 0,249 -22,575 17,803 -464,13 -942,4 -1407,3 -472,0 -943,1 -1414,1 H 8507 c -207,0 -499,-17 -692,12 25,-764 10,-1669 5,-2453 -2,-214 -22,-642 -16,-813 z m 5927,-42 c 0,-38 -3,-75 0,-119 7,-119 -109,-164 -221,-164 l -5037,11 c -169,0 -843,-20 -906,60 -45,57 -50,423 -51,525 -4,377 -13,755 -14,1135 l 5,1921 c 0,61 -8,106 23,147 90,118 222,112 376,104 320,-16 1076,-8 1473,-8 338,0 918,-11 1245,2 -39,107 -30,254 -35,383 -192,6 -476,0 -677,1 -122,0 -262,57 -258,167 4,94 130,156 241,156 l 1456,1 c 190,0 415,36 437,-142 8,-71 -30,-130 -81,-159 -61,-35 -139,-24 -220,-24 l -575,-1 -14,-311 c -4,-31 -18,-48 -19,-74 l 2420,-6 c 168,-1 355,32 410,-95 54,-124 33,-1901 33,-2156 z"
                      id="path1"
                    />
                    <path
                      d="m 12806,15434 c -15,31 10,5 -28,35 -124,99 -381,190 -551,153 -82,-18 -186,-89 -253,-128 -300,-172 -209,-337 -349,-412 -58,-32 -258,-13 -350,-12 -367,3 -2103,-7 -2228,55 -90,45 -115,137 -187,194 -82,67 -121,113 -283,91 -105,-13 -210,-60 -245,-135 -97,-210 -150,-371 35,-543 36,-34 194,-109 267,-114 100,-7 238,56 274,107 87,123 39,105 174,112 25,1 52,11 83,15 211,25 523,10 747,10 l 1524,5 c 85,1 233,4 249,-133 10,-90 -40,-55 30,-150 93,-125 144,-196 287,-280 218,-129 338,-162 588,-78 77,26 197,115 213,162 -50,3 -225,8 -271,-2 -201,-43 -223,37 -296,109 -62,63 -113,119 -178,178 -56,52 -149,88 -118,221 16,73 83,180 120,235 187,276 120,272 402,301 112,12 229,5 344,4 z m -1358,-872 c -121,13 -1487,7 -1731,7 -190,0 -387,12 -575,10 -44,-49 -46,-87 -137,-146 -248,-160 -414,-140 -660,-36 -132,56 -248,152 -311,257 -66,109 -124,314 -88,475 25,114 109,330 171,396 84,90 213,168 375,199 305,58 527,-60 694,-283 22,-29 34,-61 57,-86 164,-6 367,8 534,12 185,5 373,3 558,4 114,0 1076,-3 1101,10 23,26 53,87 74,120 78,128 180,202 312,280 200,118 319,195 618,164 259,-27 629,-214 729,-449 34,-81 75,-231 53,-327 -180,-13 -666,21 -796,-18 -18,-37 -4,-38 -31,-78 l -143,-192 137,-149 c 76,-82 26,-45 215,-37 99,4 193,-4 289,-2 86,1 181,28 258,-11 52,-26 130,-92 115,-158 -51,-211 -213,-367 -368,-495 -101,-84 -254,-140 -420,-157 -220,-23 -304,7 -471,89 -274,135 -449,329 -559,601 z"
                      id="path2"
                    />
                    <path
                      d="m 8178,18164 c 70,-50 212,-84 333,-155 180,-105 -53,-76 411,-71 732,9 1475,4 2209,7 l 1906,3 c 63,0 68,8 112,37 72,48 299,153 309,168 -1634,24 -3302,12 -4943,13 -103,0 -238,8 -337,-2 z m -754,171 c 27,116 247,101 371,101 l 6139,19 c 76,0 154,4 205,-35 39,-29 77,-92 54,-160 -23,-69 -186,-170 -255,-208 -101,-56 -210,-104 -315,-160 -84,-45 -225,-138 -311,-163 -73,-21 -95,-50 -177,-59 l -3536,5 c -161,0 -1039,-24 -1145,40 -44,27 -94,63 -150,87 -249,108 -401,184 -647,302 -90,43 -264,99 -233,231 z"
                      id="path3"
                    />
                    <path
                      d="m 8770,15067 c 58,-253 -293,-325 -341,-80 -51,266 287,317 341,80 z"
                      id="path4"
                    />
                  </g>
                </g>
              </svg>
            </a>
          </li>
          {/*<li className="x-nav-item-social-media-link suche-link"></li>*/}
          <li className="x-nav-item-language-selector">
            <LanguageSelector />
          </li>
        </ul>
      </div>
    </>
  );
};

export default injectIntl(BigHeader);
